import { newE2EPage } from "@stencil/core/testing";

describe("number-format", () => {
    it("should render a component", async () => {
        const page = await newE2EPage();
        await page.setContent(`<ux-number-format value="1000" locale="de-DE" />`);
        const el = await page.find("ux-number-format");
        expect(el.innerHTML.trim()).toBe("1.000");
        expect(el).toHaveClass("hydrated");
    });

    it("should render a component", async () => {
        const page = await newE2EPage();
        await page.setContent(`<ux-number-format value="1000" locale="us-US" />`);
        const el = await page.find("ux-number-format");
        expect(el.innerHTML.trim()).toBe("1,000");
        expect(el).toHaveClass("hydrated");
    });

    it("should match to snapshot", async () => {
        const page = await newE2EPage();
        await page.setContent(`<ux-number-format value="1000" locale="de-DE" />`);
        const el = await page.find("ux-number-format");
        expect(el).toMatchSnapshot();
    });
});
